import 'proxy-polyfill';

import MobileAppPageView from '../marketing/mobile_apps';
import AdSkin from '../common/adskin';
import MenuSlide from '../common/side_menu';
import '../common/components/search';

import { handleMegaNavMoreLinkClick, handleMegaNavCloseLinkClick } from './navigation'

import {
    NotificationsCollection,
    NotificationsBadgeView,
    NotificationCenterView,
} from '../notifications/notify'

import SignInView from './sign_in_out'
import HeaderNavView from './search_icon'
import PulldownMenu from './pulldown'
import fixHeader from './subnav'
import {PartnerIntegration} from "~/common/partner_integration";

import { ajax_csrf_setup } from '../common/ajax_csrf_setup'
import { liveBind } from 'evite'
import { popup_window, card_height, configure_selectboxes } from '../common/utils'
import { local } from 'retention-bank';
import evite from 'evite';

const { hide, css, show } = evite.dom;

// the following allows you to use the document.querySelectorAll('selector')::map syntax
let { forEach } = Array.prototype;


// PolyFill for new Event in IE
(function () {
  if ( typeof window.CustomEvent === "function" ) return false; //If not IE

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

// PollyFill for DomParser.parseFromString
(function(DOMParser) {

	var DOMParser_proto = DOMParser.prototype,
	  real_parseFromString = DOMParser_proto.parseFromString;

	// Firefox/Opera/IE throw errors on unsupported types
	try {
		// WebKit returns null on unsupported types
		if ((new DOMParser).parseFromString("", "text/html")) {
			// text/html parsing is natively supported
			return;
		}
	} catch (ex) {}

	DOMParser_proto.parseFromString = function(markup, type) {
		if (/^\s*text\/html\s*(?:;|$)/i.test(type)) {
			var
			  doc = document.implementation.createHTMLDocument("")
			;
	      		if (markup.toLowerCase().indexOf('<!doctype') > -1) {
        			doc.documentElement.innerHTML = markup;
      			}
      			else {
        			doc.body.innerHTML = markup;
      			}
			return doc;
		} else {
			return real_parseFromString.apply(this, arguments);
		}
	};

}(DOMParser));

/** Notification Center **/
const notificationCenterSetup = () => {
    if(!window.client_data.is_logged_in) return;

    const navCenter = document.getElementById('nav_nctr');
    if (!navCenter) return;
    window.notifications = new NotificationsCollection({
        fetchCallback: (collection) => {
            if (collection.models.length === 0) {
                const bell = document.body.querySelector('#nav_nctr .icon-notification');
                if (bell) bell.setAttribute('class', 'icon icon-notification-empty');

            }
        }
    });
    evite.when('document.ready', 'block js').then(function() {
        let nav_support = true;
        let nav_center_pulldown = null;

        document.getElementsByClassName('unviewed-count')::forEach((element) => {
            new NotificationsBadgeView({
                el: element,
                collection: notifications,
            });
        });

        document.getElementsByClassName('account-more')::forEach((element) => {
            let pulldown = new PulldownMenu({
                el: element
            });
            if (element.id === "nav_nctr") {
                nav_center_pulldown = pulldown;
            }
        });

        if (navCenter) {
            new NotificationCenterView({
                el: navCenter,
                collection: notifications,
                pulldown: nav_center_pulldown,
                nav_support: nav_support,
            });

            if (evite.features.isEnabled('navigation-center-header-button')) {
                evite.show(navCenter);
            }
        }

        if (document.location.pathname === '/all-notifications') {
            new NotificationCenterView({
                el: document.getElementById('all_notifications'),
                collection: notifications,
                pulldown: null,
                nav_support: false,
            });
        }
    });
};
/** End Notification Center **/

/** NavBar **/
const navBarSetup = () => {
    window.evite.resolve('sign-in-view', new SignInView());
    /**
     ** End Sign In/Out View in NAV
     **/

    if(window.is_modal === true) {
        // don't want to do this stuff in a modal
        return;
    }

    MenuSlide.create();
    const header = document.getElementById('header');
    const spacer = document.getElementById('header_spacer');
    const isViewInvitation = evite.hasClass(header, 'view-invitation');
    
    if (!header) return;

    // if it's view invitation, we need to wait for the component
    // to fully mount before we can calculate offsetHeights
    if (isViewInvitation) {
        evite.when('view-invitation-loaded').then(() => {
            callStickyHeaderFunc(isViewInvitation);
        });
    } else {
        callStickyHeaderFunc(isViewInvitation);
    }

    if (!spacer) return;

    window.card_height = card_height;
    window.popup_window = popup_window;
    if (window.is_mobile_site && !window.is_card) {
        window.menu_padding = 52; // allow space for top menu/nav bar on mobile
    } else {
        window.menu_padding = 0;
    }

    if (window.browserBlast) {
        window.browserBlast({
            devMode: false,
            supportedIE: '11',
            message: 'You are using an old version of Internet Explorer that is not supported by Evite. Please <a href="http://browsehappy.com" target="_blank">upgrade</a> for the best experience.'
        });
    }

    const cookieWarning = document.getElementById('cookie-warning');
    if (!window.location.hash) {
        if (cookieWarning && !local.get('cookie-warning')) {
            local.set('cookie-warning', 1);

            show(cookieWarning);
            css(cookieWarning, null);
            css(spacer, {height: (header.clientHeight + window.menu_padding)});

            if (evite.detects.isMobile) {
                let navElem = document.getElementById("event_view_tabs");
                if (navElem) {
                    // move down the event view tab bar by the height of the cookie warning div
                    let currTop = navElem.offset.top;
                    let warningHeight = cookieWarning.clientHeight;
                    navElem.offset.top =  currTop + warningHeight;
                }
            }
        }
    }

    if(cookieWarning){
      liveBind(cookieWarning, 'click', 'a.close', function() {
          hide(cookieWarning);
          window.cookie_dismissed = true;
          css(spacer, {height: (header.clientHeight + window.menu_padding)})
      });
    }
  
    new HeaderNavView();
    css(spacer, { height: (header.clientHeight + window.menu_padding) });
    fixHeader()

};

async function callStickyHeaderFunc(isViewInvitation) {
    const ad = document.getElementById('ad_mobile_top');

    if (evite.detects.isMobile && evite.experiments.inExperiment('sticky_header')) {
        initStickyHeader(isViewInvitation);
        if (ad) {
            // if there's an ad in the header, call the set up func again to adjust layout
            evite.when('ad-mobile-top').then(() => {
                initStickyHeader(isViewInvitation, ad);
            });
        }
    }
}

function initStickyHeader(isViewInvitation, ad) {
    const headerEl = document.getElementById('header');
    const universalNavEl = headerEl.querySelector('.universal-nav.mobile');
    const mobileTabsEl = document.querySelector('.mobile-event-view-tabs');
    const adHeight = ad ? ad.clientHeight : 0;
    const headerElHeight = isViewInvitation ? adHeight + universalNavEl.offsetHeight + mobileTabsEl.offsetHeight : headerEl.offsetHeight;

    // add div to push down content so fixed header doesn't cover it
    evite.css(document.getElementById('fixed-header-spacer'), {height: headerElHeight});
    
    if (ad) {
        const offsetToRemoveAd = headerElHeight * 2;
        const offsetToShowAd = headerElHeight;

        evite.addClass(document.getElementById('slide_right'), 'withAd');
        if (isViewInvitation) {
            evite.css(mobileTabsEl, {top: adHeight + universalNavEl.offsetHeight - 2});
        }

        document.addEventListener('scroll', event => {
            let currOffset = window.pageYOffset;

            if (currOffset > offsetToRemoveAd) {
                evite.css(ad, {marginTop: adHeight * -1});
                // view invitation has two non-adjacent headers
                if (isViewInvitation) {
                    evite.css(universalNavEl, {marginTop: isViewInvitation ? 0 : adHeight * -1});
                    evite.css(mobileTabsEl, {marginTop: adHeight * -1});
                }
            }
            else if (currOffset < offsetToShowAd) {
                evite.css(ad, {marginTop: 0});
                // view invitation has two non-adjacent headers
                if (isViewInvitation) {
                    evite.css(universalNavEl, {marginTop: 0});
                    evite.css(mobileTabsEl, {marginTop: 0});
                }
            }
        });
    }
    else if (isViewInvitation) {
        evite.css(mobileTabsEl, {top: universalNavEl.offsetHeight + adHeight - 2});
    }
}
/** End NavBar **/

/** MEGA NAV **/
evite.when('block js', 'page.render').then(function () {
  if (evite.detects.isDesktop) {
    let header = document.getElementById('header'),
        mega = document.getElementsByClassName('mega-nav-wrapper'),
        invitationLi = document.getElementById('create_invitation_li'),
        cardsLi = document.getElementById('cards_li'),
        planningLi = document.getElementById('party_planning_li'),
        megaClose = document.getElementsByClassName('mega-nav-close'),
        headerHeight = header ? header.clientHeight : 0;
    
    if (!header) return;
    
    if(mega.length < 1 || megaClose.length < 1)
      return;  // not all pages have the entire menu (event view it's not present)

    for (let i = 0; i < mega.length; i++) {
      mega[i].style.top = headerHeight + 'px';
      megaClose[i].addEventListener('click', handleMegaNavCloseLinkClick);
    }

    if (invitationLi) {
      invitationLi.addEventListener("mouseover", function () {
        show(document.getElementById('mega-nav'));
      });
    }
    if (cardsLi) {
      cardsLi.addEventListener("mouseover", function () {
        show(document.getElementById('mega-nav-cards'));
      });
    }
    if (planningLi) {
      planningLi.addEventListener("mouseover", function () {
        show(document.getElementById('mega-nav-planning'));
      });
    }
  }

  let megaMore = document.getElementsByClassName('mega-more');
  for (let i = 0; i < megaMore.length; i++) {
    megaMore[i].addEventListener('click', handleMegaNavMoreLinkClick);
  }
});
/** END MEGA NAV **/


/** Main Init **/
const runMainInit = () => {
    let partner_data = window.partner_data;
    if (!partner_data) {
        partner_data = {};
    }

    window.partner_integration = new PartnerIntegration(partner_data);

    /*
        Fix for fixed elements on mobile browsers which tend to jump around when form fields are focused on,
        due to the mobile keyboard sliding up.
        This 'unfixes' the fixed elements and prevents the mobile keyboard form causing issues.
    */
    if ('ontouchstart' in document.documentElement) {
        let bodyNode = document.querySelector('body');
        liveBind(bodyNode, 'focus', 'input, textarea', () => bodyNode.classList.add('fixFixed'));
        liveBind(bodyNode, 'blur', 'input, textarea', () => bodyNode.classList.remove('fixFixed'));
    }

    configure_selectboxes();
    new MobileAppPageView();
    window.AdSkin = AdSkin;
    evite.resolvePromiseByName('adSkin', AdSkin);
};
/** End Main Init **/

evite.logAndContinue(ajax_csrf_setup);
evite.logAndContinue(navBarSetup);
evite.logAndContinue(notificationCenterSetup);
evite.logAndContinue(runMainInit);



// WEBPACK FOOTER //
// ./assets/es6/nav/index.es6